import { c as _c } from "react/compiler-runtime";
import { useDonationFormConfig, useDonationFormContext, useDonationFormValues } from '@/donationPages/_dependencies/helpers';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import type { DonateNextIntlKeys, StripeChangeEvent, StripeEventHandlerScope } from './types';
function useStripeEventHandler(scope) {
  const $ = _c(18);
  const t = useTranslations("nextjs.donate");
  const {
    stripePublicKey
  } = useDonationFormConfig();
  const {
    setValue,
    setBusy,
    clearErrors,
    setError
  } = useDonationFormContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["_layout"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [layout] = useDonationFormValues(t0);
  const [complete, setComplete] = useState(false);
  let t1;
  if ($[1] !== clearErrors || $[2] !== layout || $[3] !== scope || $[4] !== setBusy || $[5] !== setError || $[6] !== setValue || $[7] !== stripePublicKey || $[8] !== t) {
    t1 = function handleChange(event) {
      setValue("stripe_token", stripePublicKey, {
        shouldTouch: true
      });
      if (event.elementType === "iban") {
        setValue("_stripe_iban_country", event.country || undefined, {
          shouldTouch: true,
          shouldValidate: true
        });
      }
      const isComplete = event.complete && !event.error;
      setComplete(isComplete);
      if (isComplete && layout === "iframe") {
        clearErrors("_stripe_complete");
      }
      if (!event.error) {
        return clearErrors("stripe_token");
      }
      setError("stripe_token", {
        message: t(`errors.stripe_${scope}_${event.error.code}` as DonateNextIntlKeys)
      });
      setBusy(false);
    };
    $[1] = clearErrors;
    $[2] = layout;
    $[3] = scope;
    $[4] = setBusy;
    $[5] = setError;
    $[6] = setValue;
    $[7] = stripePublicKey;
    $[8] = t;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  const handleChange = t1;
  let t2;
  if ($[10] !== complete || $[11] !== layout || $[12] !== setValue) {
    t2 = function handleBlur() {
      if (layout !== "iframe") {
        return;
      }
      setValue("_stripe_complete", complete, {
        shouldTouch: true
      });
    };
    $[10] = complete;
    $[11] = layout;
    $[12] = setValue;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  const handleBlur = t2;
  let t3;
  if ($[14] !== complete || $[15] !== handleBlur || $[16] !== handleChange) {
    t3 = {
      handleChange,
      handleBlur,
      complete
    };
    $[14] = complete;
    $[15] = handleBlur;
    $[16] = handleChange;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
}
export default useStripeEventHandler;